export default __webpack_public_path__ + "static/media/0f313ba6fe4c08051fd6a62f5c7b1564.e70b73e7.png";